import { useRef } from 'react';
import { Modal, Button, Typography, Empty } from 'antd';
import { QRCodeCanvas } from 'qrcode.react';

const { Text } = Typography;

// Construye la URL pública del equipo codificada en el QR.
// El frontend usa HashRouter, por lo que el hash '#' precede al path.
const publicUrl = (token) => `${window.location.origin}/#/q/${token}`;

export default function QrEquipoModal({ open, onClose, equipo }) {
  const ref = useRef(null);
  const token = equipo?.public_token;

  const download = () => {
    const canvas = ref.current?.querySelector('canvas');
    if (!canvas) return;
    const a = document.createElement('a');
    a.href = canvas.toDataURL('image/png');
    a.download = `qr-${equipo?.nombre || 'equipo'}.png`;
    a.click();
  };

  return (
    <Modal open={open} onCancel={onClose} title={`QR — ${equipo?.nombre || ''}`} footer={null}>
      {token ? (
        <div style={{ textAlign: 'center' }} ref={ref}>
          <QRCodeCanvas value={publicUrl(token)} size={220} includeMargin />
          <p>
            <Text type="secondary">
              Pega este QR en el equipo. Cualquiera puede ver el estado y reportar fallas.
            </Text>
          </p>
          <Button type="primary" onClick={download}>
            Descargar PNG
          </Button>
        </div>
      ) : (
        <Empty description="Este equipo aún no tiene token público. Guarda el equipo para generarlo." />
      )}
    </Modal>
  );
}
